import React from 'react';
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  LabelList
} from 'recharts';

const OrdersByServerColumnChart = ({ data }) => {
  const safeData = Array.isArray(data)
    ? [...data]
        .map(d => ({
          server: d.server_name ?? 'Unknown',
          orders: d.total_orders ?? 0
        }))
        // Sort by highest orders
        .sort((a, b) => b.orders - a.orders)
        // Optional: limit to top 10
        .slice(0, 10)
    : [];

  return (
    <ResponsiveContainer width="100%" height={300}>
      <BarChart
        data={safeData}
        margin={{ top: 20, right: 20, left: 20, bottom: 50 }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis
          dataKey="server"
          tick={{ fontSize: 12 }}
          angle={-45}
          textAnchor="end"
          interval={0}
        />
        <YAxis />
        <Tooltip formatter={(val) => [`${val} orders`, 'Total']} />
        <Bar dataKey="orders" fill="#3B82F6">
          <LabelList dataKey="orders" position="top" fill="#000" fontSize={12} />
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

export default OrdersByServerColumnChart;
